import React from 'react'
import { string } from 'prop-types'
import fetch from 'isomorphic-fetch'
import Sucess from '../Messages/Success'
import TranslationContext from '../../../utils/TranslationContext'
import styles from './FileUploadInput.styl'

export default class FileUploadInput extends React.Component {

	static propTypes = {
		file: string,
		type: string
	}

	static contextType = TranslationContext

	state = {
		selectedFile: ''
	}

	handleselectedFile(event) {
		this.setState({
			selectedFile: event.target.files[0]
		})
	}
	handleUpload() {
		const { type } = this.props
		const body = new FormData()
		body.append('file', this.state.selectedFile, this.state.selectedFile.name)
		body.append('type', type)
		fetch('/api/athletes/file', {
			method: 'POST',
			body,
			credentials: 'include'
		})
			.then(r => {
				this.setState({ processing: false, success: true })
				setTimeout(() => { this.setState({ success: false, selectedFile: '' }) }, 1500)
			})
	}

	render() {
		const { i18n } = this.context
		const { selectedFile, processing, success } = this.state
		return (
			<div className={ styles['input'] }>
				{ success ? <Sucess /> : null }
				{ selectedFile ?
					<div className={ styles['upload-container'] }>
						<div
							className={ styles['description-container'] }
						>
							<small>{ selectedFile.name }</small>
						</div>
						<div
							className={ styles.labelfile }
							onClick={ () => {
								if (processing) { return }
								this.setState({ processing: true },
									this.handleUpload.bind(this)
								)
							} }
						>
							<small>{ i18n`upload_file_label` }</small>
						</div>
					</div> :
					<input className={ styles.inputfile } type="file" onChange={ this.handleselectedFile.bind(this) } />
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/FileUploadInput/FileUploadInput.js